import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import Whatsapp from './pages/Whatsapp';
import FilterState from './context/filters/FilterState';
import AuthorizationError from '../AuthorizationError';
import accessCheckPromise from '../../../../utils/accessCheck';
import { logoutUser } from '../../../toolkit/slices/users/userSlice';
import { useDispatch } from 'react-redux';

function App() {
	const [access, setAccess] = useState(null);
	const [loading, setLoading] = useState(true); // Track loading state
	const dispatch = useDispatch();
	useEffect(() => {
		// Invoke the promise function
		accessCheckPromise().then(res => {
			setAccess(res);
			setLoading(false); // Stop loading once we have the access result
		}).catch(() => {
			dispatch(logoutUser());
		});
	}, []);

	if (loading) {
		// You might want to show a loading spinner or some other placeholder
		return <div>Loading...</div>;
	}

	if (access == false) {
		return <AuthorizationError />;
	}

	return (
		<FilterState>
			<Whatsapp />
		</FilterState>
	);
}

export default App;
